import { activeTutorialPathOperations } from "../modules/activeTutorialPath";
import { batchActions } from "../modules/chainReducer";
import { tutorialOperations } from "../modules/tutorial";
import { tutorialGroups } from ".";

const getActionToBeginTutorialPath = tutorialPath => {
  const firstTutorial = tutorialGroups.allIdsByPath[tutorialPath][0];

  return batchActions([
    activeTutorialPathOperations.setActiveTutorialPath(tutorialPath),
    tutorialOperations.setActiveTutorial(firstTutorial)
  ]);
};

export default getActionToBeginTutorialPath;
